import TaxExemption from 'components/RichProfile/MyAccount/TaxClaim/TaxExemption/TaxExemption';
import { withTaxExemptionProps } from 'viewModel/richProfile/myAccount/taxClaim/withTaxExemptionProps';

export default withTaxExemptionProps(TaxExemption);
